import React, { useContext } from 'react';
import axios from 'axios';

import { Box, Tooltip } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';

import { apiRoute } from '../../../../App';
import { CaseContext } from '../../../../context/CaseContext';

const ChargesViewTable = (props) => {
    const {
        setViolationBalance,
        setViolationView,
        setViolation,
        chargesRows,
    } = props;

    const {
        setViolationId,
        citationView,
    } = useContext(CaseContext);

    const getViolationId = (params) => {
        setViolationId(params.row.id);

        params.row.dueDate = citationView.courtDatetime;
        setViolationView(params.row);

        setViolationBalance(parseFloat(params.row.remainingBalance));

        //* -------------------- VIOLATION GET FOR SENTENCIND INFO (violation) ---------------------
        axios.get(`${apiRoute}/api/ViolationTbls/${params.row.id}`)
            .then(res => {
                let creditPerDay = params.row.remainingBalance / res.data.daysInLieu
                let totalCredit = creditPerDay * res.data.timeServed

                setViolation({ ...res.data, creditApplied: totalCredit });
            })
            .catch(err => {
                console.log("❌ VIOLATION BY VIOLATION ID ERR");
            })
    }

    const columns = [
        {
            field: 'currentStatute',
            headerName: 'Statute',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={params.value}
                        sx={{ border: '1px solid white' }}
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    fontSize: '.9rem',
                                    border: '1px solid white',
                                    borderRadius: '0px',
                                    backgroundColor: '#4c4e52',
                                    fontWeight: params.row.courtAppearRqd === 'Y' ? 'bold' : 'inherit'
                                },
                            },
                        }}
                        arrow
                        placement="bottom-end"
                    >
                        <span
                            style={{
                                color: params.row.courtAppearRqd === 'Y' ? 'red' : 'inherit',
                                fontWeight: params.row.courtAppearRqd === 'Y' ? 'bold' : 'inherit'
                            }}
                        >
                            {params.value}
                        </span>
                    </Tooltip>
                )
            }
        },
        {
            field: 'description',
            headerName: 'Violation',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={params.value}
                        sx={{ border: '1px solid white' }}
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    fontSize: '.9rem',
                                    border: '1px solid white',
                                    borderRadius: '0px',
                                    backgroundColor: '#4c4e52',
                                    fontWeight: params.row.courtAppearRqd === 'Y' ? 'bold' : 'inherit'
                                },
                            },
                        }}
                        arrow
                        placement="bottom-end"
                    >
                        <span
                            style={{
                                color: params.row.courtAppearRqd === 'Y' ? 'red' : 'inherit',
                                fontWeight: params.row.courtAppearRqd === 'Y' ? 'bold' : 'inherit'
                            }}
                        >
                            {params.value}
                        </span>
                    </Tooltip>
                )
            }
        },
        {
            field: 'remainingBalance',
            headerName: 'Remaining Balance',
            flex: 1,
            align: 'right',
            headerAlign: 'right',
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip
                            title={
                                new Intl.NumberFormat('en-US',
                                    {
                                        style: 'currency',
                                        currency: 'USD',
                                        maximumFractionDigits: 2
                                    })
                                    .format(params.value)}
                            sx={{ border: '1px solid white' }}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        fontSize: '.9rem',
                                        border: '1px solid white',
                                        borderRadius: '0px',
                                        backgroundColor: '#4c4e52',
                                        fontWeight: params.row.courtAppearRqd === 'Y' ? 'bold' : 'inherit'
                                    },
                                },
                            }}
                            arrow
                            placement="bottom-end"
                        >
                            <span
                                style={{
                                    color: params.row.courtAppearRqd === 'Y' ? 'red' : 'inherit',
                                    fontWeight: params.row.courtAppearRqd === 'Y' ? 'bold' : 'inherit'
                                }}
                            >
                                {
                                    new Intl.NumberFormat('en-US',
                                        {
                                            style: 'currency',
                                            currency: 'USD',
                                            maximumFractionDigits: 2
                                        })
                                        .format(params.value <= 0.00 ? 0.00 : params.value)
                                }
                            </span>
                        </Tooltip>
                    </>
                )
            },
        },
        {
            field: 'paymentPlan',
            headerName: 'Enrolled In Payment Plan',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            type: 'boolean',
            valueGetter: (value) => { return value && Boolean(value?.isActive); },
        }
    ];

    const minHeight = chargesRows.length < 1 ? '21.5vh' : 'inherit';

    return (
        <Box sx={{ height: minHeight }}>
            <DataGridPremium
                rows={chargesRows}
                columns={columns.map((column, index) => ({
                    ...column,
                    headerClassName: index === 0 ? 'first-column-header' : index === columns.length - 1 ? 'last-column-header' : '',
                    cellClassName: index === 0 ? 'first-column-cell' : index === columns.length - 1 ? 'last-column-cell' : '',
                }))}
                disableMultipleRowSelection
                onRowClick={getViolationId}
                density="compact"
                initialState={{
                    pagination: { paginationModel: { pageSize: 25 } },
                }}
                pageSizeOptions={[25, 50, 100]}
                localeText={{
                    noRowsLabel:
                        'No violations with outstanding balances',
                }}
                sx={{
                    '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
                        marginTop: '1em',
                        marginBottom: '1em',
                    },
                    maxHeight: '21.5vh',
                    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                        outline: "none !important",
                    }, "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus": {
                        outline: "none !important",
                    },
                    '.first-column-header': {
                        paddingLeft: '5em', // Adjust the padding value as needed
                    },
                    '.first-column-cell': {
                        paddingLeft: '5em', // Adjust the padding value as needed
                    },
                }}
            />
        </Box>
    );
}

export default ChargesViewTable;